import React, { useState, useEffect, useRef } from 'react';
import '../styles/GuessInput.css';

function GuessInput({ skylanders, guesses, onSubmit, disabled }) {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target) &&
          inputRef.current && !inputRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setInput(value);

    if (value.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const matches = skylanders
      .filter(name => name.includes(value) && !guesses.includes(name))
      .slice(0, 10);

    setSuggestions(matches);
    setShowSuggestions(matches.length > 0);
  };

  const handleSuggestionClick = (name) => {
    setInput(name);
    setShowSuggestions(false);
    inputRef.current?.focus();
  };

  const handleSubmit = () => {
    if (input.trim() && !disabled) {
      onSubmit(input.trim());
      setInput('');
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="input-container">
      <input
        ref={inputRef}
        type="text"
        id="guess-input"
        placeholder="Enter name..."
        autoComplete="off"
        value={input}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        disabled={disabled}
      />
      <button
        id="submit-btn"
        onClick={handleSubmit}
        disabled={disabled}
      >
        GUESS
      </button>
      
      {showSuggestions && (
        <div ref={suggestionsRef} className="suggestions">
          {suggestions.map((name) => (
            <div
              key={name}
              className="suggestion-item"
              onClick={() => handleSuggestionClick(name)}
            >
              {name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default GuessInput;
